module.exports = __webpack_public_path__ + "static/media/UN_Pic_Banner.4e37cd73.png";